import React, {useEffect, useState, Fragment, Suspense} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import Home from '../pages/static/Home';
import Mission from '../pages/static/Mission';
import NotFound from '../pages/static/404';
import Statics from '../pages/static/Statics';
import Meatcuts from '../pages/static/Meatcuts';
import Products from '../pages/Products';
import Faq from '../pages/FAQ';
import Recipes from '../pages/Recipes';
import Farmers from '../pages/Farmers';
import Breeds from '../pages/Breeds';
import Coupons from '../pages/Coupons';
import Header from '../pages/inc/Header';
import Footer from '../pages/inc/Footer';
import {currentLang, isProduct, getPath} from './../utils/functions.js';
import { useTranslation } from 'react-i18next';
import {isNil, upperFirst, isEmpty} from 'lodash';



const App = () =>{
    // change your language
    //const defaultLang = process.env.REACT_APP_LANG;
    const {pathname} = useLocation();
    const [URLS, setURLS] = useState(null);
    const [items, setItems] = useState(null);
    const {t} = useTranslation();
    const [sectionClass, setSectionClass] = useState(null);
    //console.log(isProduct);
    

    const maybeSmoothScroll = e => {
      var clicked_link = e.target.closest( 'a' );
      if ( clicked_link && clicked_link.getAttribute( 'href' ) && clicked_link.getAttribute( 'href' ).startsWith( '#' ) ) {
        document.querySelector( clicked_link.getAttribute( 'href' ) ).scrollIntoView( { behavior: 'smooth' } );
      }
    }
    
    useEffect(() => {
      if(!isNil(window.urlMaps) && !isNil(window.urlMaps[currentLang()]) && isNil(URLS)){
        setURLS(window.urlMaps[currentLang()]);
        var arr = [];
        window.animals = [];
        window.urls = [];
        window.urlMaps[currentLang()].map(item=>{
          window.urls[item.name] = item.pattern;
          if(item['items']){
            item['items'].map(row=>{
              var tempURL = row.pattern.replace('/'+currentLang(), '');
              if(!isEmpty(row.pattern) && !isEmpty(tempURL)){
                arr.push(row);
                if(row.component == 'products'){
                  window.animals[row.name] = row.pattern.split('/')[2];
                }
              }
            })
          }
        })
        setItems(arr);
      }
    }, [window.urlMaps])
    

    useEffect(()=>{
      if(isProduct()){
        setSectionClass('products');
      }
    }, [window.product_urls])
    //var test = window.urlMaps[currentLang()];
    /*useEffect(() => {
      if(isProduct(t('menu.products'))){
        setSectionClass('products');
      }
    }, [])
    */

    var Components = {
      faq: Faq,
      statics: Statics,
      mission: Mission,
      products: Products,
      breeds: Breeds,
      meatcuts: Meatcuts,
      farmers: Farmers,
      recipes: Recipes,
      coupons: Coupons
    }
    //console.log(URLS);
    //console.log(items);
      return(
        <div className="App" id="root" className={sectionClass && sectionClass}>
            <Fragment>
            <Header />
            <div className='page--body' onClick={maybeSmoothScroll}>
              <Switch>
              {/*
              <Redirect exact from="/" to={"/"+currentLang()+"/"} component={Home} />

              <Route exact path={"/"+currentLang()+"/"} component={Home} />
              <Route exact path={"/"+currentLang()+"/404"} component={NotFound} />

              <Route path={"/"+currentLang()+"/"+t("menu.animal")+"/:filter?"} component={Home} />
              <Route path={"/"+currentLang()+"/"+t("menu.meatcuts")+"/:slug?"} component={Meatcuts} />
              <Route path={"/"+currentLang()+"/"+t("menu.products")+"/:slug?"} component={Products} />
              <Route path={"/"+currentLang()+"/"+t("menu.faq")+"/:filter?"} component={Faq} />
              <Route path={"/"+currentLang()+"/"+t("menu.faq1")+"/:filter?"} component={Faq} />
              <Route path={"/"+currentLang()+"/"+t("menu.farmers")+"/:slug?/:page?"} component={Farmers} />
              <Route path={"/"+currentLang()+"/"+t("menu.breeds")+"/:slug?/:page?"} component={Breeds} />
              <Route path={"/"+currentLang()+"/"+t("menu.recipes")+"/:slug?/:page?"} component={Recipes} />
              <Route exact path={"/"+currentLang()+"/"+t("menu.mission")} component={Mission} />
              <Route path={"/"+currentLang()+"/"+t("menu.coupons")} component={Coupons} />
              <Route path={"/"+currentLang()+"/"+t("menu.coupons1")} component={Coupons} />
              <Route path={"/"+currentLang()+"/"+t("menu.coupons2")} component={Coupons} />
              <Route path={"/"+currentLang()+"/"+t("menu.coupons3")} component={Coupons} />
              <Route path="*" component={Statics} />
              */}
              
                <Redirect exact from="/" to={"/"+currentLang()+"/"} component={Home} />

                <Route exact path={"/"+currentLang()+"/"} component={Home} />
                <Route exact path={"/"+currentLang()+"/404"} component={NotFound} />
                <Route path={"/"+currentLang()+"/"+t("menu.animal")+"/:filter?"} component={Home} />

                {items && items.map((item, index)=>{
                    if(!isEmpty(item.pattern)){
                      return (
                        <Route path={item.pattern} name={item.name} component={Components[item.component]} />
                      )
                    }
                })}
                {URLS && URLS.map((item, index)=>{ 
                    if(!isEmpty(item.pattern)){
                      return (
                        <Route path={item.pattern} name={item.name} component={Components[item.component]} />
                      )
                    }
                })}
                {URLS && 
                  <Route exact path="*" component={Statics} />
                }
              
              </Switch>
            </div>
            <Footer />
            </Fragment>
        </div>
      );
}

export default App;
